export type StockCategory = "Kozmetik" | "Temizlik" | "Masaj Yağı" | "Tekstil" | "Tırnak Malzemesi" | "Diğer";

export interface StockItem {
  id: string;
  name: string;
  category: StockCategory;
  currentStock: number;
  minStock: number;
  unit: string;
  supplier: string;
  lastEntryDate: string;
  lastExitDate: string;
  entryQuantity: number;
  exitQuantity: number;
  alert: boolean;
  unitPrice: number;
}

export const stockItems: StockItem[] = [
  {
    id: "stk-001",
    name: "Lavanta Uçucu Yağı 100ml",
    category: "Masaj Yağı",
    currentStock: 12,
    minStock: 5,
    unit: "adet",
    supplier: "Aroma Doğal Ürünler",
    lastEntryDate: "2026-04-15",
    lastExitDate: "2026-05-07",
    entryQuantity: 20,
    exitQuantity: 8,
    alert: false,
    unitPrice: 180,
  },
  {
    id: "stk-002",
    name: "Sıcak Taş Seti (Bazalt)",
    category: "Tekstil",
    currentStock: 3,
    minStock: 2,
    unit: "set",
    supplier: "Spa Ekipman Ltd.",
    lastEntryDate: "2026-03-01",
    lastExitDate: "2026-04-20",
    entryQuantity: 5,
    exitQuantity: 2,
    alert: false,
    unitPrice: 450,
  },
  {
    id: "stk-003",
    name: "Anti-Aging Serum 50ml",
    category: "Kozmetik",
    currentStock: 2,
    minStock: 5,
    unit: "adet",
    supplier: "DermaPro Tedarik",
    lastEntryDate: "2026-03-20",
    lastExitDate: "2026-05-06",
    entryQuantity: 15,
    exitQuantity: 13,
    alert: true,
    unitPrice: 320,
  },
  {
    id: "stk-004",
    name: "Beyaz Peştemal",
    category: "Tekstil",
    currentStock: 45,
    minStock: 20,
    unit: "adet",
    supplier: "Tekstil Çarşısı",
    lastEntryDate: "2026-04-01",
    lastExitDate: "2026-05-08",
    entryQuantity: 60,
    exitQuantity: 15,
    alert: false,
    unitPrice: 45,
  },
  {
    id: "stk-005",
    name: "Jel Oje Kırmızı #205",
    category: "Tırnak Malzemesi",
    currentStock: 4,
    minStock: 3,
    unit: "adet",
    supplier: "NailArt Toptan",
    lastEntryDate: "2026-04-10",
    lastExitDate: "2026-05-05",
    entryQuantity: 12,
    exitQuantity: 8,
    alert: false,
    unitPrice: 65,
  },
  {
    id: "stk-006",
    name: "Genel Temizlik Solüsyonu 5L",
    category: "Temizlik",
    currentStock: 6,
    minStock: 3,
    unit: "adet",
    supplier: "Temizlik Market",
    lastEntryDate: "2026-04-25",
    lastExitDate: "2026-05-02",
    entryQuantity: 10,
    exitQuantity: 4,
    alert: false,
    unitPrice: 85,
  },
  {
    id: "stk-007",
    name: "Hindistan Cevizi Yağı 500ml",
    category: "Masaj Yağı",
    currentStock: 1,
    minStock: 4,
    unit: "adet",
    supplier: "Aroma Doğal Ürünler",
    lastEntryDate: "2026-03-10",
    lastExitDate: "2026-05-08",
    entryQuantity: 10,
    exitQuantity: 9,
    alert: true,
    unitPrice: 150,
  },
  {
    id: "stk-008",
    name: "Tuz Terapisi Tuzu 1kg",
    category: "Diğer",
    currentStock: 8,
    minStock: 5,
    unit: "adet",
    supplier: "Haloterapi Ürünleri",
    lastEntryDate: "2026-04-05",
    lastExitDate: "2026-04-28",
    entryQuantity: 12,
    exitQuantity: 4,
    alert: false,
    unitPrice: 120,
  },
  {
    id: "stk-009",
    name: "Nemlendirici Maske 30 adet",
    category: "Kozmetik",
    currentStock: 15,
    minStock: 10,
    unit: "paket",
    supplier: "DermaPro Tedarik",
    lastEntryDate: "2026-03-25",
    lastExitDate: "2026-05-04",
    entryQuantity: 25,
    exitQuantity: 10,
    alert: false,
    unitPrice: 280,
  },
  {
    id: "stk-010",
    name: "Manikür Seti Profesyonel",
    category: "Tırnak Malzemesi",
    currentStock: 3,
    minStock: 2,
    unit: "set",
    supplier: "NailArt Toptan",
    lastEntryDate: "2026-02-15",
    lastExitDate: "2026-04-15",
    entryQuantity: 5,
    exitQuantity: 2,
    alert: false,
    unitPrice: 220,
  },
];